import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-assign',
  templateUrl: './assign.component.html',
  styleUrls: ['./assign.component.scss'],
  standalone: false,
})
export class AssignComponent {
  animal: string;
  name: string;
  location: Location;
  selectedItem = 'table';
  constructor(
    location: Location,
    public dialog: MatDialog,
    public router: Router,
  ) {
    const path = location.path();
    if (path != '') {
      this.selectedItem = location.path().replace(/\//g, '');
    }
  }

  listClick(event, newValue) {
    this.selectedItem = newValue; // don't forget to update the model here
    // ... do other stuff here ...
    // console.log(this.selectedItem);
  }
}
